import getConfig from 'next/config';
import type {
  BorderRadius,
  Font,
  Options,
} from '@checkout.com/checkout-web-components';

import isProductionMode from '@utils/isProductionMode';

const { publicRuntimeConfig } = getConfig();

type BuildFlowConfigArgs = {
  borderRadius: BorderRadius;
  locale: string;
  paymentSession: { id: string; payment_session_token: string };
  componentOptions: Options['componentOptions'];
  translations?: Options['translations'];
  onPaymentCompleted?: Options['onPaymentCompleted'];
  handleSubmit?: Options['handleSubmit'];
  onError: Options['onError'];
  /**
   * Colour of the components' outer/container borders. Pass 'transparent' to
   * let the app own the row borders while keeping the input-field borders
   * (driven separately by colorFormBorder). Defaults to the LF border colour.
   */
  colorBorder?: string;
  colorPrimary?: string;
};

export const buildFlowConfig = ({
  borderRadius,
  locale,
  paymentSession,
  componentOptions,
  translations,
  onPaymentCompleted,
  handleSubmit,
  onError,
  colorBorder = '#dfe4f3',
  colorPrimary = '#000',
}: BuildFlowConfigArgs): Options => ({
  appearance: {
    colorPrimary,
    colorAction: '#FFCB03',
    colorBorder,
    colorBackground: '#FFF',
    colorDisabled: '#dfe4f3',
    colorOutline: '#ffcb0352',
    colorFormBackground: '#FFF',
    colorFormBorder: '#dfe4f3',
    colorError: '#FF573E',
    borderRadius,
    subheading: {
      fontFamily: 'Arial, sans-serif',
      fontSize: '18px',
      lineHeight: '27px',
      fontWeight: 700,
      letterSpacing: 0,
      color: '#000',
    } as Partial<Font>,
    label: {
      fontFamily: 'Arial, sans-serif',
      fontSize: '14px',
      lineHeight: '21px',
      fontWeight: 700,
      letterSpacing: 0,
    },
    input: {
      fontFamily: 'Arial, sans-serif',
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 400,
      letterSpacing: 0,
    },
    button: {
      fontFamily: 'Arial, sans-serif',
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 700,
      letterSpacing: 0,
      color: '#000',
    } as Partial<Font>,
  },
  componentOptions,
  translations,
  locale,
  paymentSession,
  publicKey: publicRuntimeConfig.checkoutComPublicKey,
  environment: isProductionMode ? 'production' : 'sandbox',
  onPaymentCompleted,
  handleSubmit,
  onError,
});
